<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca4a"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="shipmentPayment_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="shipmentPayment_statusQuery_button"
          @click="statusQuery"
        >
          更新支付结果
        </el-button>
        <el-button
          v-if="shipmentPayment_orderShareBatch_button"
          @click="OrderShareBatch"
        >
          批量分账
        </el-button>
        <el-button
          v-if="getLimit('shipmentPayment_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :checkbox-config="{
        labelField: 'name',
        strict: true,
        checkMethod: checkMethod2
      }"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="250"
          sortable
          how-header-overflow
        />
        <template v-slot:header>
          <el-input v-model="listQuery.orderDetailNumber" placeholder="请输入内容" clearable/>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="outTradeNo"
          title="交易流水号"
          min-width="250"
          sortable
          how-header-overflow
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outTradeNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="网商支付订单号"
          min-width="230"
          sortable
          how-header-overflow
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerMerchantName"
          title="付款人"
          min-width="130"
          sortable
          how-header-overflow
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerMerchantName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="balancePayType"
          title="支付类型"
          :formatter="formatterBalancePayType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.balancePayType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in balancePayStatusType"
              v-show="item.value != 2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="memo"
          title="备注"
          min-width="130"
          sortable
          how-header-overflow
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.memo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="shipmentPayment_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <i class="el-icon-s-unfold" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              shipmentPayment_rePayment_button && scope.row.status === 'FAIL'
            "
            class="item"
            effect="dark"
            content="重新支付"
            placement="top"
          >
            <vxe-button type="text" @click="rePayment(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              shipmentPayment_OrderShare_button &&
                scope.row.status === 'SUCCESS'
            "
            class="item"
            effect="dark"
            content="分账"
            placement="top"
          >
            <vxe-button type="text" @click="OrderShare(scope.row)">
              <i class="el-icon-s-finance" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="ModelCashMoney"
      title="重新支付"
      width="530"
      height="300"
      resize
    >
      <CashMoney ref="CashMoneyRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <orderDetail ref="detailRef" />
    </vxe-modal>
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import CashMoney from "./components/cashMoney.vue";
import {
  balancePayQuery,
  getBalancePay,
  orderShareApply
} from "@/api/InternetBanking";
import orderDetail from "./components/orderDetail";
import { getLimit } from "@/utils/getLimit.js";
export default {
  components: {
    CashMoney,
    orderDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/mybankBalancePay/exportBalanceShipmentPay", //导出接口
        name: "托运人支付"
      },
      ModelCashMoney: false,
      loading: false,
      dialogTableVisible: false,
      shipmentPayment_search_button: false, //查询
      shipmentPayment_statusQuery_button: false, //更新支付结果
      shipmentPayment_orderShareBatch_button: false, //批量分账
      shipmentPayment_rePayment_button: false, //重新支付
      shipmentPayment_OrderShare_button: false, //分账
      shipmentPayment_detail_button: false, //详情
      tableData: [],
      errorData: [],
      listQuery: {
        source: "shipment",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      statusOptions: [
        { value: "SUCCESS", label: "成功" },
        { value: "FAIL", label: "失败" },
        { value: "DEALING", label: "处理中" },
        { value: "FINISHED", label: "分账完成" }
      ],
      balancePayStatusType: [
        { value: 0, label: "打款" },
        { value: 1, label: "预付" },
        { value: 2, label: "车队分账" }
      ],
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      tuteship: false
    };
  },
  created() {
    this.findList();
    this.shipmentPayment_search_button = getLimit(
      "shipmentPayment_search_button"
    );
    this.shipmentPayment_statusQuery_button = getLimit(
      "shipmentPayment_statusQuery_button"
    );
    this.shipmentPayment_orderShareBatch_button = getLimit(
      "shipmentPayment_orderShareBatch_button"
    );
    this.shipmentPayment_rePayment_button = getLimit(
      "shipmentPayment_rePayment_button"
    );
    this.shipmentPayment_OrderShare_button = getLimit(
      "shipmentPayment_OrderShare_button"
    );
    this.shipmentPayment_detail_button = getLimit(
      "shipmentPayment_detail_button"
    );
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getBalancePay(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //支付状态查询
    statusQuery() {
      const rLoading = this.openLoading();
      balancePayQuery().then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    getShareType(balancePayType) {
      if (balancePayType == 2) {
        return 2; //车队分账
      } else {
        return 0; //0打款，1预付
      }
    },
    OrderShare(a) {
      this.accdata = [];
      this.accdata.push({
        relateOrderNo: a.orderNo,
        shareType: this.getShareType(a.balancePayType)
      });
      this.$confirm("是否申请分账?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          orderShareApply(this.accdata).then(response => {
            rLoading.close();
            if (response.status === 500) {
              this.dialogTableVisible = true;
              this.errorData = response.data;
            } else {
              let type = response.status === 0 ? "success" : "error";
              this.findList();
              this.$message({
                message: response.msg,
                type: type
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 批量分账
    OrderShareBatch() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      this.$refs.xTable.clearCheckboxRow();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({
          message: "请选择需要分账的项",
          type: "warning"
        });
        return false;
      }
      if (checkedRowArray.length > 100) {
        this.$message({
          message: "批量处理最多100条数据",
          type: "warning"
        });
        return false;
      }
      this.accdata = [];
      checkedRowArray.map(item => {
        this.accdata.push({
          relateOrderNo: item.orderNo,
          shareType: this.getShareType(item.payType)
        });
      });
      const rLoading = this.openLoading();
      orderShareApply(this.accdata)
        .then(response => {
          rLoading.close();
          if (response.status === 500) {
            this.dialogTableVisible = true;
            this.errorData = response.data;
          } else {
            let type = response.status === 0 ? "success" : "error";
            this.findList();
            this.$message({
              message: response.msg,
              type: type
            });
          }
        })
        .finally(f => {
          rLoading.close();
          this.findList();
        });
    },
    //重新支付
    rePayment(c) {
      this.$refs.CashMoneyRef.getInfo(c);
      this.ModelCashMoney = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    hideModel() {
      this.ModelCashMoney = false;
      this.findList();
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译状态
    formatterBalancePayType({ cellValue }) {
      const item = this.balancePayStatusType.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    checkMethod2({ row }) {
      return row.status === "SUCCESS";
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    }
  }
};
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

div ::v-deep .el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}

div ::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
